// ============================================================
// SUNKEY · shared interactions & motion
// Safe to load on any page — every PDP-specific block is guarded.
// ============================================================
(() => {
  'use strict';

  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('in-view'), i * 60);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('.reveal, .vs-row').forEach((el) => io.observe(el));
  } else {
    $$('.reveal, .vs-row').forEach((el) => el.classList.add('in-view'));
  }

  const header = $('#site-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 80) header.classList.add('shadow-md');
      else                     header.classList.remove('shadow-md');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // UGC carousel arrows (any page that has #ugc-track + arrows)
  const ugcTrack = document.getElementById('ugc-track');
  const ugcPrev  = document.getElementById('ugc-prev');
  const ugcNext  = document.getElementById('ugc-next');
  if (ugcTrack && ugcPrev && ugcNext) {
    const step = () => Math.min(ugcTrack.clientWidth * 0.8, 600);
    ugcPrev.addEventListener('click', () => ugcTrack.scrollBy({ left: -step(), behavior: 'smooth' }));
    ugcNext.addEventListener('click', () => ugcTrack.scrollBy({ left:  step(), behavior: 'smooth' }));
  }

  // Quick-add buttons flash
  document.querySelectorAll('.quick-add').forEach((b) => {
    b.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const original = b.innerHTML;
      b.innerHTML = '✓';
      b.classList.add('bg-mint-pop', 'text-deep-plum');
      b.classList.remove('bg-deep-plum', 'text-cream');
      setTimeout(() => {
        b.innerHTML = original;
        b.classList.remove('bg-mint-pop', 'text-deep-plum');
        b.classList.add('bg-deep-plum', 'text-cream');
      }, 1200);
    });
  });

  // Newsletter mock submit
  document.querySelectorAll('#newsletter-form, #newsletter').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const msg = document.getElementById('newsletter-msg');
      msg?.classList.remove('hidden');
      form.reset();
      setTimeout(() => msg?.classList.add('hidden'), 3500);
    });
  });

  // Anchor smooth-scroll
  $$('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (id.length < 2) return;
      const tgt = document.querySelector(id);
      if (tgt) {
        e.preventDefault();
        tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Spotlight slider — lock manual horizontal scrolling so the track can't be
  // dragged/nudged off-snap; it advances only via its arrows / dots / autoplay.
  $$('[data-spotlight-track]').forEach((track) => {
    track.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) e.preventDefault();
    }, { passive: false });
    let sx = 0, sy = 0;
    track.addEventListener('touchstart', (e) => {
      sx = e.touches[0].clientX;
      sy = e.touches[0].clientY;
    }, { passive: true });
    track.addEventListener('touchmove', (e) => {
      if (Math.abs(e.touches[0].clientX - sx) > Math.abs(e.touches[0].clientY - sy)) e.preventDefault();
    }, { passive: false });
  });
})();
